(() => {
  const root = document.querySelector('.ip-geo-tip');
  if (!root) return;
  const enabled = String(root.dataset.enabled || 'true') === 'true';
  if (!enabled) return;
  const EU_CODES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','NL','PL','PT','RO','SK','SI','ES','SE','DE','CH','NO'];
  const US_CODE = 'US';
  const AU_CODE = 'AU';
  const closeDays = Number(root.dataset.closeDays || 7);
  const switchDays = Number(root.dataset.switchDays || 180);
  const DOMAIN_US = 'us.snapmaker.com';
  const DOMAIN_EU = 'eu.snapmaker.com';
  const DOMAIN_AU = 'au.snapmaker.com';
  const DOMAIN_GLOBAL = 'shop.snapmaker.com';
  const textEl = root.querySelector('#ip-geo-tip-text');
  const switchEl = root.querySelector('#ip-geo-tip-switch');
  const closeEl = root.querySelector('#ip-geo-tip-close');
  const getCountryCode = async () => {
    try {
      const res = await fetch('https://api.snapmaker.com/v1/ip-geolocation');
      const data = await res.json();
      if (res.ok && data?.countryCode) return String(data.countryCode).toUpperCase();
    } catch {}
    try {
      const res = await fetch('https://ipinfo.io/json?token=860ed8b1d6f7cc');
      if (res.ok) {
        const data = await res.json();
        const code = data?.country;
        if (code) return String(code).toUpperCase();
      }
    } catch {}
    return '';
  };
  const now = () => Date.now();
  const ms = (days) => days * 24 * 60 * 60 * 1000;
  const get = (k) => {
    try { return JSON.parse(localStorage.getItem(k)) || null; } catch { return null; }
  };
  const set = (k) => {
    try { localStorage.setItem(k, JSON.stringify({ t: now() })); } catch {}
  };
  const within = (k, days) => {
    const v = get(k);
    if (!v || !v.t) return false;
    return now() - Number(v.t) < ms(days);
  };
  const CLOSED_KEY = 'ip-geo-tip:closed';
  const SWITCHED_KEY = 'ip-geo-tip:switched';
  const toDomain = (cc) => {
    if (!cc) return DOMAIN_GLOBAL;
    if (cc === US_CODE) return DOMAIN_US;
    if (cc === AU_CODE) return DOMAIN_AU;
    if (EU_CODES.includes(cc)) return DOMAIN_EU;
    return DOMAIN_GLOBAL;
  };
  const toRegionLabel = (d) => {
    if (d === DOMAIN_US) return 'US';
    if (d === DOMAIN_AU) return 'AU';
    if (d === DOMAIN_EU) return 'EU';
    return 'Global';
  };
  const toCountryName = (cc) => {
    if (cc === 'DE') return 'Germany';
    if (cc === 'FR') return 'France';
    if (cc === 'ES') return 'Spain';
    if (cc === 'IT') return 'Italy';
    if (cc === 'NL') return 'Netherlands';
    return '';
  };
  const setMessage = (domain, code) => {
    if (!textEl) return;
    if (domain === DOMAIN_US) {
      textEl.innerHTML = "It looks like you're in the <strong>US</strong>. Switch to the <strong>US Store</strong> for local shipping and pricing.";
      return;
    }
    if (domain === DOMAIN_AU) {
      textEl.innerHTML = "It looks like you're in <strong>Australia</strong>. Switch to the <strong>AU Store</strong> for local shipping and pricing.";
      return;
    }
    if (domain === DOMAIN_EU) {
      const countryName = toCountryName(code);
      const regionLabel = countryName || 'EU';
      const storeLabel = countryName ? `EU Store – ${countryName}` : 'EU Store';
      textEl.innerHTML = `It looks like you're in <strong>${regionLabel}</strong>. Switch to the <strong>${storeLabel}</strong> for local shipping and pricing.`;
      return;
    }
    textEl.innerHTML = "For international shipping and regional availability, visit the <strong>Global Store</strong>.";
  };
  const toLanguagePrefix = (cc) => {
    if (cc === 'DE') return 'de';
    if (cc === 'FR') return 'fr';
    if (cc === 'ES') return 'es';
    if (cc === 'IT') return 'it';
    if (cc === 'NL') return 'nl';
    return 'en';
  };
  const pathWithoutLang = (() => {
    const seg = location.pathname.split('/')[1];
    const langs = ['en', 'de', 'fr', 'es', 'it', 'nl'];
    if (langs.includes(seg)) return location.pathname.replace(`/${seg}`, '') || '/';
    return location.pathname;
  })();
  const buildSwitchUrl = (domain, code) => {
    const lang = toLanguagePrefix(code);
    const langPrefixes = ['de', 'fr', 'es', 'it', 'nl'];
    const newPath = langPrefixes.includes(lang) ? `/${lang}${pathWithoutLang}` : `${pathWithoutLang}`;
    return `https://${domain}${newPath}${location.search || ''}`;
  };
  const show = () => {
    setTipTop();
    root.style.display = 'block';
    requestAnimationFrame(setTipTop);
  };
  const hide = () => { root.style.display = 'none'; };
  // Compute the sticky header's bottom edge and mirror it to a dedicated CSS
  // variable used by the tip's `top:`. We always write (clamped to >= 0) instead
  // of only writing when `end > 0`, so the value can never freeze at a stale
  // page-load offset (announcement + header) that leaves a gap below the header.
  const setTipTop = () => {
    const el = document.querySelector('store-header') || document.querySelector('.cc-header');
    if (!el) return;
    const bottom = el.getBoundingClientRect().bottom;
    const top = Math.max(0, bottom);
    document.documentElement.style.setProperty('--ip-geo-tip-top', `${top.toFixed(1)}px`);
  };
  setTipTop();
  window.addEventListener('resize', setTipTop);
  window.addEventListener('scroll', setTipTop);
  window.addEventListener('load', setTipTop);
  window.addEventListener('on:breakpoint-change', setTipTop);
  const init = async () => {
    if (within(CLOSED_KEY, closeDays) || within(SWITCHED_KEY, switchDays)) return;
    const code = await getCountryCode();
    const recommendedDomain = toDomain(code);
    const currentDomain = location.host;
    if (recommendedDomain === currentDomain) {
      // Same domain, but for EU also check that language matches
      if (recommendedDomain !== DOMAIN_EU) return;
      const currentLang = (location.pathname.split('/')[1] || '').toLowerCase();
      const knownLangs = ['en', 'de', 'fr', 'es', 'it', 'nl'];
      const currentLangPrefix = knownLangs.includes(currentLang) ? currentLang : 'en';
      const recommendedLang = toLanguagePrefix(code);
      if (recommendedLang === currentLangPrefix) return;
    }
    setMessage(recommendedDomain, code);
    if (switchEl) {
      switchEl.setAttribute('href', buildSwitchUrl(recommendedDomain, code));
    }
    // Give the browser a frame to lay the header out, then position + show.
    // setTipTop() runs inside show() and again on the next frame, so the tip's
    // sticky top reflects the live header bottom even if fonts/layout are late.
    await new Promise((r) => requestAnimationFrame(r));
    show();
    if (closeEl) {
      closeEl.addEventListener('click', () => {
        set(CLOSED_KEY);
        hide();
      });
    }
    if (switchEl) {
      switchEl.addEventListener('click', () => {
        set(SWITCHED_KEY);
      });
    }
  };
  init();
})();
